import { render, staticRenderFns } from "./voucherRecoverManager.vue?vue&type=template&id=5823b79b&scoped=true"
import script from "./voucherRecoverManager.vue?vue&type=script&lang=js"
export * from "./voucherRecoverManager.vue?vue&type=script&lang=js"
import style0 from "./voucherRecoverManager.vue?vue&type=style&index=0&id=5823b79b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823b79b",
  null
  
)

export default component.exports